// Client-Service für das Glocken-Benachrichtigungszentrum (Verlauf ausgelöster
// Alerts). Der Cron schreibt jeden Treffer nach users/{uid}/alertHits/{id};
// hier liest der Client sie LIVE (onSnapshot) und markiert sie als gelesen.
//
// Firestore-Rules: users/{uid}/** ist owner-only → der eingeloggte User darf
// seine eigenen Hits lesen + read-Flag setzen. Der Cron schreibt via Admin-SDK
// (umgeht Rules). Kein Custom-Index nötig: orderBy('ts') ist Single-Field.

import { collection, query, orderBy, limit, onSnapshot, doc, updateDoc, deleteDoc } from '../lib/fsCompat';
import { db } from '../firebase';

/**
 * Abonniert die letzten Alert-Treffer des Users (neueste zuerst, max 30).
 * @param {string} uid
 * @param {(hits: Array) => void} cb  erhält [{ id, alertId, type, coinSym, title, body, ts, read }]
 * @returns {() => void} unsubscribe
 */
export function subscribeAlertHits(uid, cb) {
  if (!uid) return () => {};
  const q = query(
    collection(db, 'users', uid, 'alertHits'),
    orderBy('ts', 'desc'),
    limit(30),
  );
  return onSnapshot(
    q,
    (snap) => cb(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
    (err) => { console.warn('[alertHits] subscribe:', err?.message); cb([]); },
  );
}

/**
 * Markiert alle übergebenen ungelesenen Hits als gelesen (Best-Effort, parallel).
 */
export async function markAllHitsRead(uid, hits) {
  if (!uid || !Array.isArray(hits)) return;
  const unread = hits.filter((h) => !h.read);
  if (!unread.length) return;
  await Promise.all(
    unread.map((h) =>
      updateDoc(doc(db, 'users', uid, 'alertHits', h.id), { read: true }).catch(() => {}),
    ),
  );
}

/**
 * Löscht abgelaufene (ausgelöste) Benachrichtigungen aus dem Verlauf.
 * Ohne `ids` werden ALLE übergebenen Hits gelöscht; mit `ids` nur diese.
 */
export async function deleteAllHits(uid, hits, ids = null) {
  if (!uid || !Array.isArray(hits) || !hits.length) return;
  const targets = ids ? hits.filter((h) => ids.includes(h.id)) : hits;
  await Promise.all(
    targets.map((h) =>
      deleteDoc(doc(db, 'users', uid, 'alertHits', h.id)).catch(() => {}),
    ),
  );
}
